import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Add, Close, Dashboard } from '@mui/icons-material';
import { Box, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { DashboardOption } from '../types';
import { OPTION_LIST_ICON_MAPPER } from '../constants';

interface Props {
  dashboardOption: DashboardOption;
  onSelect?: (dashboard: DashboardOption) => void;
}

export const DashboardListItem = ({ dashboardOption, onSelect }: Props) => {
  const classes = useStyles();

  const handleOpen = () => {
    if (onSelect) {
      onSelect(dashboardOption);
    }
  };

  return (
    <Paper className={classes.container}>
      <Box className="card">
        <Box className="header">
          <RenderWithCondition
            condition={!!dashboardOption.url}
            fallBack={
              <Tooltip title="Dashboard content unavailable">
                <IconButton size="small" disabled>
                  <Close />
                </IconButton>
              </Tooltip>
            }
          >
            <Tooltip title="Open dashboard">
              <IconButton size="small" onClick={handleOpen}>
                <Add />
              </IconButton>
            </Tooltip>
          </RenderWithCondition>

          {dashboardOption.icon ? OPTION_LIST_ICON_MAPPER[dashboardOption.icon] : <Dashboard color="primary" />}

          <Typography color="textSecondary" variant="h6" component="span">
            {dashboardOption.name}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

const useStyles = makeStyles({
  container: {
    padding: '1rem 0.5rem',

    '& .card': {
      gap: '0.5rem',
      display: 'flex',
      flexDirection: 'column',

      '& .header': {
        gap: '0.5rem',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      },
    },
  },
});
